import Flash from '../Flash';
export const GLOBAL_EVENT_TYPES = {
    WINDOW_RESIZE: 'window_resize',
};
/**
 * Binds listener events that will fire off on the Flash service.
 */
class GlobalListeners {
    static bind() {
        if (this.is_bound)
            return;
        window.addEventListener('resize', this.fireWindowResizeEvent);
        this.is_bound = true;
    }
    static unbind() {
        this.is_bound = false;
        window.removeEventListener('resize', this.fireWindowResizeEvent);
    }
}
GlobalListeners.is_bound = false;
GlobalListeners.fireWindowResizeEvent = function () {
    Flash.publish(GLOBAL_EVENT_TYPES.WINDOW_RESIZE);
};
export { GlobalListeners };
export default GlobalListeners;
//# sourceMappingURL=GlobalListeners.js.map